import { KkmServerAdapter } from './adapter';

let runtimeAdapter: KkmServerAdapter | null = null;

/**
 * Единственный экземпляр адаптера на вкладку.
 *
 * Защита от параллельных команд к устройству (`device_busy`) живёт в приватном
 * `activeOperations` экземпляра, поэтому между разными экземплярами она не работает:
 * health-опрос чипа встал бы в очередь KKMServer перед печатью чека.
 */
export function getKkmServerAdapter(): KkmServerAdapter {
  runtimeAdapter ??= new KkmServerAdapter();

  return runtimeAdapter;
}

/** Подмена экземпляра из спек. `null` возвращает модуль к ленивому созданию — вызывать в `afterEach`. */
export function setKkmServerAdapter(adapter: KkmServerAdapter | null): void {
  runtimeAdapter = adapter;
}
